module.exports = __webpack_public_path__ + "static/img/11.5091e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/11.jpg
// module id = IaG7
// module chunks = 16